import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { API, BACKEND, fmtWaktu, pesanGalat } from "../lib/api";
import { useAuth } from "../auth";
import Shell from "../components/Shell";
import BukuView from "../components/BukuView";
import PrioritasHariIni from "../components/PrioritasHariIni";
import {
  JudulHalaman, KerangkaBaris, KeadaanGalat, KeadaanKosong,
  KELAS_TABEL, KELAS_TH, KELAS_TD,
} from "../components/kit";

const MODE_TAB = [["langsung", "LANGSUNG"], ["historis", "HISTORIS"], ["gabungan", "GABUNGAN"]];

function BuktiKontrol() {
  const { user } = useAuth();
  const [mode, setMode] = useState("langsung");
  const [data, setData] = useState(null);
  const [galat, setGalat] = useState(null);
  const muat = () => {
    setData(null); setGalat(null);
    API.get(`/kpi?mode=${mode}`).then((r) => setData(r.data)).catch((e) => setGalat(pesanGalat(e)));
  };
  useEffect(muat, [mode]);
  return (
    <div>
      <div className="flex gap-1 mb-4" role="tablist" aria-label="Mode metrik">
        {MODE_TAB.map(([k, l]) => (
          <button key={k} role="tab" aria-selected={mode === k} data-testid={`tab-mode-${k}`} onClick={() => setMode(k)}
            className={`px-3 py-1.5 text-xs font-medium border transition-colors duration-150 ${mode === k ? "bg-primary text-primary-foreground" : "hover:bg-secondary"}`}>
            {l}
          </button>
        ))}
      </div>
      {galat && <KeadaanGalat testid="galat-kpi" pesan={galat} onCoba={muat} />}
      {!data && !galat && <KerangkaBaris testid="memuat-kpi" n={5} />}
      {data && (
        <div className="space-y-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="panel rounded p-5" data-testid="kpi-target-terlewat">
              <p className="label-kecil">Lewat batas waktu</p>
              <p className="font-data text-3xl font-bold mt-3 tabular">{data.target_terlewat}</p>
            </div>
            <div className="panel rounded p-5" data-testid="kpi-tak-bertuan">
              <p className="label-kecil">Akun tanpa pemilik</p>
              <p className="font-data text-3xl font-bold mt-3 tabular">{data.tak_bertuan.jumlah}</p>
            </div>
            <div className="panel rounded p-5" data-testid="kpi-umur-tertua">
              <p className="label-kecil">Menganggur terlama</p>
              <p className="font-data text-3xl font-bold mt-3 tabular">
                {data.tak_bertuan.tertua_hari != null ? `${data.tak_bertuan.tertua_hari} hari` : "—"}
              </p>
            </div>
            <div className="panel rounded p-5">
              <p className="label-kecil">Sebaran umur (hari)</p>
              <div className="mt-2 space-y-1" data-testid="ember-umur">
                {Object.entries(data.tak_bertuan.ember).map(([k, v]) => (
                  <div key={k} className="flex items-center gap-2 text-xs">
                    <span className="font-data w-14">{k}</span>
                    <div className="h-3 rounded-sm bg-primary/80" style={{ width: `${data.tak_bertuan.jumlah ? Math.max(2, (v / data.tak_bertuan.jumlah) * 100) : 0}%` }} />
                    <span className="font-data tabular">{v}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {[
            ["Median & p90 jam per sistem", data.per_sistem, "tabel-per-sistem"],
            user.peran === "admin" && data.per_pemilik
              ? ["Per pemilik akses — untuk menemukan akses tanpa pemilik aktif, bukan untuk menilai orang", data.per_pemilik, "tabel-per-pemilik"]
              : null,
          ].filter(Boolean).map(([judul, rows, testid]) => (
            <section key={testid}>
              <h3 className="font-heading font-semibold mb-2">{judul}</h3>
              {rows.length === 0 ? (
                <p className="text-sm text-muted-foreground italic">belum ada data (n=0)</p>
              ) : (
                <div className="overflow-x-auto border">
                  <table className={KELAS_TABEL} data-testid={testid}>
                    <thead>
                      <tr>
                        <th className={KELAS_TH}>Nama</th><th className={KELAS_TH}>Arah</th><th className={KELAS_TH}>n</th>
                        <th className={KELAS_TH}>Median (jam)</th><th className={KELAS_TH}>p90 (jam)</th><th className={KELAS_TH}>Terlama</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((g, i) => (
                        <tr key={i}>
                          <td className={KELAS_TD}>{g.nama}</td>
                          <td className={`${KELAS_TD} font-data`}>{g.arah}</td>
                          <td className={`${KELAS_TD} font-data`}>{g.n}</td>
                          <td className={`${KELAS_TD} font-data`}>{g.median_jam}</td>
                          <td className={KELAS_TD}>
                            {g.p90_jam != null
                              ? <span className="font-data">{g.p90_jam}</span>
                              : <span className="text-xs text-muted-foreground">{g.p90_catatan} · terlama: <span className="font-data">{g.terlama_jam}</span> jam ({g.terlama_nomor})</span>}
                          </td>
                          <td className={`${KELAS_TD} font-data text-xs`}>{g.terlama_jam} jam</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {rows.length > 0 && (
                <details className="mt-2">
                  <summary className="text-xs text-muted-foreground cursor-pointer underline decoration-dotted">tabel mentah (semua baris, n kecil terlihat jujur)</summary>
                  <div className="overflow-x-auto border mt-2">
                    <table className={KELAS_TABEL}>
                      <thead><tr><th className={KELAS_TH}>Kelompok</th><th className={KELAS_TH}>Arah</th><th className={KELAS_TH}>Nomor</th><th className={KELAS_TH}>Jam</th></tr></thead>
                      <tbody>
                        {rows.flatMap((g) => g.mentah.map((m) => (
                          <tr key={m.nomor}>
                            <td className={KELAS_TD}>{g.nama}</td>
                            <td className={`${KELAS_TD} font-data`}>{g.arah}</td>
                            <td className={`${KELAS_TD} font-data`}>{m.nomor}</td>
                            <td className={`${KELAS_TD} font-data`}>{m.jam}</td>
                          </tr>
                        )))}
                      </tbody>
                    </table>
                  </div>
                </details>
              )}
            </section>
          ))}

          {data.tak_bertuan.mentah.length > 0 && (
            <section>
              <h3 className="font-heading font-semibold mb-2">Rincian akses tanpa pemilik</h3>
              <div className="overflow-x-auto border">
                <table className={KELAS_TABEL} data-testid="tabel-mentah-yatim">
                  <thead><tr><th className={KELAS_TH}>Kode orang</th><th className={KELAS_TH}>Umur (hari)</th></tr></thead>
                  <tbody>
                    {data.tak_bertuan.mentah.map((m, i) => (
                      <tr key={i}><td className={`${KELAS_TD} font-data`}>{m.kode}</td><td className={`${KELAS_TD} font-data`}>{m.umur_hari}</td></tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          )}

          {user.peran === "admin" && (
            <button data-testid="unduh-bukti-kontrol"
              className="inline-block px-4 py-2 border text-sm transition-colors duration-150 hover:bg-secondary"
              onClick={async () => {
                const r = await API.get("/ekspor/bukti-kontrol.csv", { responseType: "blob" });
                const u = URL.createObjectURL(r.data);
                const a = document.createElement("a");
                a.href = u; a.download = `bukti_kontrol_${new Date().toISOString().slice(0, 7)}.csv`; a.click();
                URL.revokeObjectURL(u);
              }}>
              Unduh bukti_kontrol.csv
            </button>
          )}
        </div>
      )}
    </div>
  );
}

function LainLain() {
  const [rows, setRows] = useState(null);
  const [galat, setGalat] = useState(null);
  const [tutupId, setTutupId] = useState(null);
  const [catatan, setCatatan] = useState("");
  const muat = () => {
    API.get("/lain-lain").then((r) => setRows(r.data)).catch((e) => setGalat(pesanGalat(e)));
  };
  useEffect(muat, []);
  const tutup = async (id) => {
    try {
      await API.post(`/lain-lain/${id}/tutup`, { catatan_penutup: catatan });
      setTutupId(null); setCatatan(""); muat();
    } catch (e) { alert(pesanGalat(e)); }
  };
  if (galat) return <KeadaanGalat testid="galat-lain" pesan={galat} onCoba={muat} />;
  if (!rows) return <KerangkaBaris testid="memuat-lain" n={3} />;
  if (!rows.length) return <KeadaanKosong testid="kosong-lain" teks="Belum ada catatan di Buku Lain-lain." />;
  return (
    <div className="overflow-x-auto border">
      <table className={KELAS_TABEL} data-testid="tabel-lain-lain">
        <thead>
          <tr>
            <th className={KELAS_TH}>Waktu</th><th className={KELAS_TH}>Kategori</th><th className={KELAS_TH}>Pemohon</th>
            <th className={KELAS_TH}>Kebutuhan</th><th className={KELAS_TH}>Keadaan</th><th className={KELAS_TH}>Aksi</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} data-testid={`lain-${r.id}`}>
              <td className={`${KELAS_TD} font-data text-xs`}>{fmtWaktu(r.waktu)}</td>
              <td className={KELAS_TD}>{r.kategori}</td>
              <td className={KELAS_TD}>{r.nama_pemohon}</td>
              <td className={KELAS_TD}>{r.kebutuhan_singkat}</td>
              <td className={KELAS_TD}>
                {r.status === "sudah"
                  ? <span className="text-xs font-medium text-emerald-600 dark:text-emerald-400">SUDAH — {r.catatan_penutup}</span>
                  : <span className="text-xs font-medium text-zinc-500">BELUM DITANGANI</span>}
              </td>
              <td className={KELAS_TD}>
                {r.status === "belum" && (
                  tutupId === r.id ? (
                    <div className="flex gap-2">
                      <input data-testid={`input-penutup-${r.id}`} value={catatan} onChange={(e) => setCatatan(e.target.value)}
                        placeholder="Catatan penutup" className="border bg-background px-2 py-1 text-xs w-48" />
                      <button data-testid={`btn-simpan-penutup-${r.id}`} onClick={() => tutup(r.id)}
                        className="px-2 py-1 bg-primary text-primary-foreground text-xs">Simpan</button>
                    </div>
                  ) : (
                    <button data-testid={`btn-tutup-lain-${r.id}`} onClick={() => setTutupId(r.id)}
                      className="px-2 py-1 border text-xs transition-colors duration-150 hover:bg-secondary">Tutup</button>
                  )
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function LaporanBulanan() {
  const [data, setData] = useState(null);
  const [galat, setGalat] = useState(null);
  const muat = () => {
    API.get("/kpi?mode=gabungan").then((r) => setData(r.data)).catch((e) => setGalat(pesanGalat(e)));
  };
  useEffect(muat, []);
  if (galat) return <KeadaanGalat testid="galat-bulanan" pesan={galat} onCoba={muat} />;
  if (!data) return <KerangkaBaris testid="memuat-bulanan" n={3} />;
  if (!data.bulanan.length) return <KeadaanKosong testid="kosong-bulanan" teks="belum ada data (n=0)" />;
  return (
    <div className="overflow-x-auto border">
      <table className={KELAS_TABEL} data-testid="tabel-bulanan">
        <thead>
          <tr>
            <th className={KELAS_TH}>Bulan</th><th className={KELAS_TH}>Baris BUKA selesai</th>
            <th className={KELAS_TH}>Baris TUTUP selesai</th><th className={KELAS_TH}>Median jam TUTUP</th><th className={KELAS_TH}>n TUTUP</th>
          </tr>
        </thead>
        <tbody>
          {data.bulanan.map((b) => (
            <tr key={b.bulan}>
              <td className={`${KELAS_TD} font-data`}>{b.bulan}</td>
              <td className={`${KELAS_TD} font-data`}>{b.buka}</td>
              <td className={`${KELAS_TD} font-data`}>{b.tutup}</td>
              <td className={`${KELAS_TD} font-data`}>{b.median_jam_tutup ?? "—"}</td>
              <td className={`${KELAS_TD} font-data`}>{b.n_tutup}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Buku() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const tabAwal = user?.peran === "manajer" ? "bukti" : (params.get("tab") || "buku");
  const [tab, setTab] = useState(tabAwal);
  const [buku, setBuku] = useState(null);
  const [galat, setGalat] = useState(null);
  const hanyaYatim = params.get("status") === "tak_bertuan";

  const muat = () => {
    setGalat(null);
    API.get("/buku").then((r) => setBuku(r.data)).catch((e) => setGalat(pesanGalat(e)));
  };
  useEffect(() => { if (tab === "buku") muat(); }, [tab]);

  const agregat = useMemo(() => {
    if (!buku) return null;
    let yatim = 0, tertua = 0, sistem = 0;
    buku.forEach((s) => {
      if (s.jumlah_tak_bertuan > 0) sistem++;
      yatim += s.jumlah_tak_bertuan;
      s.akses.forEach((a) => { if (a.umur_tak_bertuan_hari > tertua) tertua = a.umur_tak_bertuan_hari; });
    });
    return { yatim, tertua, sistem };
  }, [buku]);

  const tabs = [
    ...(user?.peran !== "manajer" ? [["buku", "Buku"], ["prioritas", "Prioritas Hari Ini"]] : []),
    ["bukti", "Bukti Kontrol"],
    ...(user?.peran === "admin" ? [["lain", "Buku Lain-lain"]] : []),
    ["bulanan", "Laporan Bulanan"],
  ];

  return (
    <Shell>
      <JudulHalaman testid="judul-buku" judul="Buku"
        sub="Semua akses yang masih terbuka. Tanda segitiga berarti akunnya sudah tidak punya pemilik." />
      <div className="flex gap-1 mb-6 border-b" role="tablist" aria-label="Tab buku">
        {tabs.map(([k, l]) => (
          <button key={k} role="tab" aria-selected={tab === k} data-testid={`tab-${k}`}
            onClick={() => { setTab(k); setParams(k === "buku" ? {} : { tab: k }); }}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors duration-150 ${tab === k ? "border-foreground" : "border-transparent text-muted-foreground hover:text-foreground"}`}>
            {l}
          </button>
        ))}
      </div>

      {tab === "buku" && (
        <>
          {galat && <KeadaanGalat testid="galat-buku" pesan={galat} onCoba={muat} />}
          {!buku && !galat && <KerangkaBaris testid="memuat-buku" n={5} />}
          {buku && buku.length === 0 && (
            <KeadaanKosong testid="kosong-buku" aksiLabel="Isi dengan data contoh"
              teks="Ruang kerja ini masih kosong. Tambahkan akses di layar Akses, atau isi dulu dengan data contoh untuk mencoba-coba."
              onAksi={async () => {
                try { await API.post("/perusahaan/isi-contoh"); muat(); }
                catch (e) { alert(pesanGalat(e)); }
              }} />
          )}
          {buku && agregat && buku.length > 0 && (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                <div className="panel panel-hover rounded p-5" data-testid="kartu-yatim">
                  <p className="label-kecil">Akun tanpa pemilik</p>
                  <p className="font-data text-3xl font-bold mt-3 tabular">{agregat.yatim}</p>
                </div>
                <div className="panel panel-hover rounded p-5">
                  <p className="label-kecil">Menganggur terlama</p>
                  <p className="font-data text-3xl font-bold mt-3 tabular">{agregat.tertua} <span className="text-base text-muted-foreground">hari</span></p>
                </div>
                <div className="panel panel-hover rounded p-5">
                  <p className="label-kecil">Akses yang terdampak</p>
                  <p className="font-data text-3xl font-bold mt-3 tabular">{agregat.sistem}</p>
                </div>
              </div>
              {hanyaYatim && (
                <p className="mb-4 text-sm" data-testid="filter-yatim-aktif">
                  Menampilkan akses tanpa pemilik saja.{" "}
                  <button className="underline" data-testid="hapus-filter" onClick={() => setParams({})}>Tampilkan semua</button>
                </p>
              )}
              <BukuView data={buku} hanyaTakBertuan={hanyaYatim} />
            </>
          )}
        </>
      )}
      {tab === "prioritas" && <PrioritasHariIni />}
      {tab === "bukti" && <BuktiKontrol />}
      {tab === "lain" && <LainLain />}
      {tab === "bulanan" && <LaporanBulanan />}
    </Shell>
  );
}
